export const ADD_REPEAT = 'ADD_REPEAT';
export const ADD = 'ADD';
export const NOT_ADD = 'NOT_ADD';
